import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobService } from 'src/app/services/job.service';
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { lang } from 'moment';
import { IJobFamily } from 'src/app/constants/models';


@Component({
  selector: 'app-job-apply-family',
  templateUrl: './job-apply-family.component.html',
  styleUrls: ['./job-apply-family.component.scss']
})
export class JobApplyFamilyComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  defaultTitle: any = this.language.jobchoose
  NumberChild: any = ['0', '1', '2', '3']
  NumberChildren: any
  TitleTH: any = [this.language.jobpersonaltitle1, this.language.jobpersonaltitle2, this.language.jobpersonaltitle3]
  ChildTitleTH: any = [this.language.jobpersonaltitle1, this.language.jobpersonaltitle2, this.language.jobpersonaltitle3, this.language.jobpersonaltitle4, this.language.jobpersonaltitle5]
  MaritalSelect: any = [this.language.jobfamdetail6, this.language.jobfamdetail7, this.language.jobfamdetail8, this.language.jobfamdetail9]
  ageform: FormArray = new FormArray([]);
  excisePersonInfo1: FormArray = new FormArray([]);
  personid: any
  Personal = true
  Education = true
  Family = false
  Experience = false

  education: any

  Score: any
  Single: any
  Married: any
  Widowed: any
  Divorced: any

  MaritalStatus: any
  Children1: any
  Children2: any
  Children3: any
  Children4: any
  Children5: any

  count = 1
  clickCount = 0
  countChild = 0
  countSister = 1

  Family1: boolean
  Family2: boolean
  Family3: boolean

  // อายุ
  married_year: any
  age: any
  age1: any
  Arrayage: any[] = []
  TMPage: any


  personidarray: any
  arage: any

  formage: any

  // ข้อมูลครอบครัว
  f_title: any = ''
  f_fname: any = ''
  f_lname: any = ''
  f_age: any = ''
  f_address: any = ''
  f_occupation: any = ''
  f_tel: any = ''
  m_title: any = ''
  b_title: any = ''
  b_fname: any = ''
  b_lname: any = ''
  b_age: any = ''
  b_occupation: any = ''
  b_address: any = ''
  b_tel: any = ''
  urgent_title: any
  ref_relation: any = ''
  ref_title: any = ''
  ref_fname: any = ''
  ref_lname: any = ''
  ref_position: any = ''
  ref_tel: any = ''
  m_fname: any = ''
  m_lname: any = ''
  m_age: any = ''
  m_occupation: any = ''
  m_address: any = ''
  m_tel: any = ''
  urgent_fname: any
  urgent_lname: any
  urgent_tel: any
  urgent_address: any
  urgent_relation: any
  s_title: any = ''
  s_fname: any = ''
  s_lname: any = ''
  s_age: any = ''
  s_address: any = ''
  s_occupation: any = ''
  s_tel: any = ''

  c_title: any = ''
  c_fname: any = ''
  c_lname: any = ''
  c_age: any = ''
  c_occupation: any = ''
  c_address: any = ''
  c_tel: any = ''

  // Req
  ReqMaritalStatus = false
  ReqNumberChildren = false
  Requrgent_title = false
  Requrgent_fname = false
  Requrgent_lname = false
  Requrgent_relation = false
  Requrgent_tel = false
  Requrgent_address = false
  Reqf_title = false
  Reqf_fname = false
  Reqf_lname = false
  Reqf_age = false
  Reqf_tel = false
  Reqf_occupation = false
  Reqf_address = false
  Reqm_title = false
  Reqm_fname = false
  Reqm_age = false
  Reqm_lname = false
  Reqm_tel = false
  Reqm_occupation = false
  Reqm_address = false
  Reqb_title = false
  Reqb_fname = false
  Reqb_lname = false
  Reqb_age = false
  Reqb_tel = false
  Reqb_occupation = false
  Reqb_address = false

  Reqc_title = false
  Reqc_fname = false
  Reqc_lname = false
  Reqc_age = false
  Reqc_tel = false
  Reqc_occupation = false
  Reqc_address = false

  ReqMarried_year = false
  Reqage1 = false
  Reqage2 = false
  Reqage3 = false
  Reqage4 = false
  Reqage5 = false

  submitted = false;

  formDataSis: FormGroup;
  formDataChild: FormGroup;

  formData: FormGroup;

  SisInfo: FormArray = new FormArray([]);
  ChildInfo: FormArray = new FormArray([]);


  unamePattern = "^[a-z0-9_-]{8,15}$";
  pwdPattern = "^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$";
  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  constructor(
    private router: Router,
    private _JobApplyService: JobService,
    private fb: FormBuilder,
  ) {
    this.createform();   ///function  เรียกฟอรม
  }




  createItem(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      b_title: [],
      b_fname: [],
      b_lname: [],
      b_age: [],
      b_occupation: [],
      b_address: [],
      b_tel: []
    });
  }
  createChildItem(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      c_title: [],
      c_fname: [],
      c_lname: [],
      c_age: [],
      c_occupation: [],
      c_address: [],
      c_tel: []
    });
  }
  createform() {
    this.formDataSis = this.fb.group({
      SisInfo: this.fb.array([this.createItem()]),
    })
    this.formDataChild = this.fb.group({
      ChildInfo: this.fb.array([]),
    })
  }

  createageform() {
    this.formDataSis = this.fb.group({
      age: this.fb.array([this.formage()]),
    })
  }

  createItemAssign(): FormGroup {   ///form excisePersonInfo1  array
    return this.fb.group({
      personid: this.personid,
      age: ['', Validators.pattern(this.mobnumPattern)],
    });
  }



  ngOnInit() {
    this.formData = this.fb.group({
      excisePersonInfo1: this.fb.array([]),
    })

    var personid = localStorage.getItem("personid");
    this.MaritalStatus = this.language.jobfamdetail6;
    this.NumberChildren = 0;
    if (this.NumberChildren == 0) {
      this.Family3 = true;
    }
  }

  addSister() {
    // this.count = this.count + 1;
    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));
    this.countSister += 1

    this.SisInfo = this.formDataSis.controls.SisInfo as FormArray;

    this.SisInfo.push(this.fb.group({
      b_title: [],
      b_fname: [],
      b_lname: [],
      b_age: [],
      b_occupation: [],
      b_address: [],
      b_tel: []
    }));

  }
  removeSister() {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));

    this.SisInfo.removeAt(this.SisInfo.length - 1);
    this.countSister -= 1
    // this.clickCount = this.clickCount - 1;
  }

  addChild() {
    // this.count = this.count + 1;
    // this.clickCount = this.count;
    // localStorage.setItem("clickCount", JSON.stringify(this.clickCount));
    this.countChild += 1

    this.ChildInfo = this.formDataChild.controls.ChildInfo as FormArray;

    this.ChildInfo.push(this.fb.group({
      c_title: [],
      c_fname: [],
      c_lname: [],
      c_age: [],
      c_occupation: [],
      c_address: [],
      c_tel: []
    }));

  }
  removeChild() {
    // var clickCount = localStorage.getItem(JSON.stringify(this.clickCount));

    this.ChildInfo.removeAt(this.ChildInfo.length - 1);
    this.countChild -= 1
    // this.clickCount = this.clickCount - 1;
  }


  goEducation() {
    this.router.navigate(['/job-apply-education']);
  }

  onclickNumberChildren(value) {
    var personid = localStorage.getItem("personid");

    this.excisePersonInfo1 = this.formData.controls.excisePersonInfo1 as FormArray;
    if (value == 0) {
      while (this.excisePersonInfo1.length !== 0) {
        this.excisePersonInfo1.removeAt(0)
      }
    } else {
      while (this.excisePersonInfo1.length !== 0) {
        this.excisePersonInfo1.removeAt(0)
      }
    }
    console.log(this.formDataChild.get('ChildInfo')['controls']);
    const objCount = (this.formDataChild.get('ChildInfo')['controls']).length;
    let val = Number(value)
    if (val > objCount) {
      for (let i = (objCount + 1); val >= i; i++) {
        console.log('add', i);

        this.addChild()
      }
    } else if (val < objCount) {
      for (let i = (objCount - 1); val <= i; i--) {
        console.log('remove', i);
        this.removeChild()
      }
    }
    this.NumberChildren = value;

    if (this.NumberChildren == 1) {
      this.Children1 = 1;

      this.NumberChildren = 1;
      // this.clickCount = 1;
      this.countChild = 1;
    }
    if (this.NumberChildren == 2) {
      this.Children1 = 1;
      this.Children2 = 2;
      this.NumberChildren = 2;
      // this.clickCount = 2;
      this.countChild = 2;
    }
    if (this.NumberChildren == 3) {
      this.Children1 = 1;
      this.Children2 = 2;
      this.Children3 = 3;
      this.NumberChildren = 3;
      // this.clickCount = 3;
      this.countChild = 3;
    }
  }

  onclickMarital(value) {
    this.MaritalStatus = value;
    this.NumberChildren = 0;
  }

  onclickTitle(value) {
    this.f_title = value;
  }

  onclickm_title(value) {
    this.m_title = value;
  }

  onclickurgent_title(value) {
    this.urgent_title = value
  }

  onclicks_title(value) {
    this.s_title = value
  }

  setQuestionOneScore(event) {
    this.Score = event
    if (this.Score == 1) {
      this.Single = 'Single'
    } else if (this.Score == 2) {
      this.Married = 'Married'
    } else if (this.Score == 3) {
      this.Widowed = 'Widowed'
    } else if (this.Score == 4) {
      this.Divorced = 'Divorced'
    }
  }

  addAge(valueAge) {

    this.Arrayage.push(valueAge);

  }

  addf_title(value) {
    this.f_title = value;
  }

  goExperience() {
    this.submitted = true;

    var personid = localStorage.getItem("personid");
    if (personid != "") {
      var arrayControl = this.formData.value.excisePersonInfo1;

      for (let i = 0; this.excisePersonInfo1.length > i; i++) {

        this.personidarray = arrayControl[i].personid

        this.arage = arrayControl[i].age

        this._JobApplyService.setAge(this.personidarray, this.arage, i + 1).subscribe(result => {
          if (result.returncode == "1000") {
            this.Family3 = true;
          } else {
            console.log(result.desc);
          }
        })
      }
      const param: IJobFamily = { personid: personid, childs: [], brother_sisters: [] }
      // Child
      var arrayControChild = this.formDataChild.value.ChildInfo;

      for (let i = 0; this.formDataChild.value.ChildInfo.length > i; i++) {

        this.c_title = arrayControChild[i].c_title || '';
        this.c_fname = arrayControChild[i].c_fname || '';
        this.c_lname = arrayControChild[i].c_lname || '';
        this.c_age = arrayControChild[i].c_age || '';
        this.c_occupation = arrayControChild[i].c_occupation || '';
        this.c_address = arrayControChild[i].c_address || '';
        this.c_tel = arrayControChild[i].c_tel || '';

        param.childs.push({ title: this.c_title, fname: this.c_fname, lname: this.c_lname, age: this.c_age, occupation: this.c_occupation, address: this.c_address, tel: this.c_tel, seq: (i + 1).toString() })
        // this._JobApplyService.setbrother(personid, this.c_title, this.c_fname, this.c_lname, this.c_age, this.c_occupation, this.c_address, this.c_tel, i + 1).subscribe(result => {
        //   if (result.returncode == "1000") {
        //     this.Family2 = true;
        //   }
        // })
      }

      // Family2
      var arrayControSis = this.formDataSis.value.SisInfo;

      for (let i = 0; this.formDataSis.value.SisInfo.length > i; i++) {

        this.b_title = arrayControSis[i].b_title || '';
        this.b_fname = arrayControSis[i].b_fname || '';
        this.b_lname = arrayControSis[i].b_lname || '';
        this.b_age = arrayControSis[i].b_age || '';
        this.b_occupation = arrayControSis[i].b_occupation || '';
        this.b_address = arrayControSis[i].b_address || '';
        this.b_tel = arrayControSis[i].b_tel || '';

        param.brother_sisters.push({ b_title: this.b_title, b_fname: this.b_fname, b_lname: this.b_lname, b_age: this.b_age, b_occupation: this.b_occupation, b_address: this.b_address, b_tel: this.b_tel, seq: (i + 1).toString() })
        // this._JobApplyService.setbrother(personid, this.b_title, this.b_fname, this.b_lname, this.b_age, this.b_occupation, this.b_address, this.b_tel, i + 1).subscribe(result => {
        //   if (result.returncode == "1000") {
        //     this.Family2 = true;
        //   }
        // })
      }

      // this._JobApplyService.setSpouse(personid, this.s_title, this.s_fname, this.s_lname, this.s_age, this.s_occupation, this.s_address, this.s_tel,).subscribe(result => {
      //   console.log(result);

      // if (result.returncode == "1000") {
      //   this.Family2 = true;
      // }
      // })

      if (this.urgent_title === undefined || this.urgent_title === '' || this.urgent_title === null) {
        this.Requrgent_title = true;
      } else {
        this.Requrgent_title = false;
      }

      if (this.urgent_fname === undefined || this.urgent_fname === '' || this.urgent_fname === null) {
        this.Requrgent_fname = true;
      } else {
        this.Requrgent_fname = false;
      }

      if (this.urgent_lname === undefined || this.urgent_lname === '' || this.urgent_lname === null) {
        this.Requrgent_lname = true;
      } else {
        this.Requrgent_lname = false;
      }

      if (this.urgent_relation === undefined || this.urgent_relation === '' || this.urgent_relation === null) {
        this.Requrgent_relation = true;
      } else {
        this.Requrgent_relation = false;
      }

      if (this.urgent_tel === undefined || this.urgent_tel === '' || this.urgent_tel === null) {
        this.Requrgent_tel = true;
      } else {
        this.Requrgent_tel = false;
      }

      if (this.urgent_address === undefined || this.urgent_address === '' || this.urgent_address === null) {
        this.Requrgent_address = true;
      } else {
        this.Requrgent_address = false;
      }
      param.family = { MaritalStatus: this.MaritalStatus, f_lname: this.f_lname, m_age: this.m_age, urgent_tel: this.urgent_tel, s_occupation: this.s_occupation, NumberChildren: this.NumberChildren, f_age: this.f_age, m_occupation: this.m_occupation, urgent_address: this.urgent_address, s_address: this.s_address, f_title: this.f_title, f_occupation: this.f_occupation, m_address: this.m_address, urgent_relation: this.urgent_relation, s_tel: this.s_tel, f_fname: this.f_fname, f_address: this.f_address, m_tel: this.m_tel, s_title: this.s_title, f_tel: this.f_tel, urgent_title: this.urgent_title, s_fname: this.s_fname, m_title: this.m_title, urgent_fname: this.urgent_fname, s_lname: this.s_lname, m_fname: this.m_fname, urgent_lname: this.urgent_lname, s_age: this.s_age, m_lname: this.m_lname, married_year: this.married_year }
      if (!this.Requrgent_title && !this.Requrgent_fname && !this.Requrgent_lname && !this.Requrgent_relation && !this.Requrgent_tel && !this.Requrgent_address) {
        this._JobApplyService.setfamilies(param).subscribe(result => {

          if (result.returncode == "1000") {
            this.router.navigate(['/job-apply-Experience']);
          } else {
            console.log(result.desc);
          }
        })
      }


    } else {
      this.router.navigate(['/job-apply-family']);
    }

  }

  onKey(event) { // without type info
    return false;
  }
  goprint() {
    console.log(this.s_fname, this.s_title);

  }
}
